import { createSelector } from 'reselect';
import {StoreState} from 'Store/Reducers';

const fetchRecords = ({ offers }: StoreState) => offers;
const byId = (_: StoreState, id) => id

export const getOfferById = createSelector(
    fetchRecords,
    byId,
    ({ entities }, id) => entities?.[id]
);

export const getOfferByIdAsObject = createSelector(
    fetchRecords,
    ({ entities }) => entities
);
